// src/api/adminApi.js
import axios from 'axios';

// Optional: Use environment variables for the base URL
// Ensure you set REACT_APP_API_URL in your .env file to match your backend URL
// Example: REACT_APP_API_URL=https://your-backend.com/api
const baseURL =  'https://lanesands.io/api'; //https://lanesands.io    //process.env.REACT_APP_API_URL ||

// Create an Axios instances
const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 60000, // optional timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Attach JWT token if available
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken'); // Adjust if using a different storage or key
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      console.warn('No token found. Requests may fail.');
    }
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle responses and errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Error Response:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers,
    } : error);

    if (error.response && error.response.status === 401) {
      // Unauthorized: clear token and redirect to login
      localStorage.removeItem('authToken');
      window.location.href = '/login'; // Adjust path if needed
    }

    return Promise.reject(error);
  }
);

// API Methods

/**
 * Fetches a paginated list of pending KYC users.
 * @param {number} [pageNumber=1] - The page number to fetch.
 * @param {number} [pageSize=10] - The number of users per page.
 * @param {string} [searchTerm=""] - An optional search term to filter results.
 * @returns {Promise} - Axios response promise with pending KYC users.
 */
const getPendingKycUsers = (pageNumber = 1, pageSize = 10, searchTerm = "") => {
  return axiosInstance.get('/admin/pending-kyc-users', {
    params: { pageNumber, pageSize, searchTerm },
  });
};

/**
 * Approves KYC for a user identified by a token.
 * @param {string} approveToken - The unique token identifying the KYC record to approve.
 * @returns {Promise} - Axios response promise.
 */
const approveKyc = (approveToken) => {
  return axiosInstance.post('/admin/approve-kyc', { token: approveToken });
};

/**
 * Rejects KYC for a user identified by a token.
 * @param {string} rejectToken - The unique token identifying the KYC record to reject.
 * @returns {Promise} - Axios response promise.
 */
const rejectKyc = (rejectToken) => {
  return axiosInstance.post('/admin/reject-kyc', { token: rejectToken });
};

/**
 * Retrieves user details by user ID.
 * @param {number|string} userId - The ID of the user to fetch.
 * @returns {Promise} - Axios response promise with user details.
 */
const getUserById = (userId) => {
  return axiosInstance.get(`/admin/users/${userId}`);
};

export default {
  getPendingKycUsers,
  approveKyc,
  rejectKyc,
  getUserById,
};
